import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Obra } from '@/types';
import * as api from './api';

export function useObras(mes?: string, includeArquivadas = false) {
  return useQuery<Obra[]>({
    queryKey: ['obras', mes ?? 'atual', includeArquivadas],
    queryFn: () => api.fetchObras(mes, includeArquivadas),
  });
}

function useInvalidateObras() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: ['obras'] });
    void queryClient.invalidateQueries({ queryKey: ['mapas'] });
  };
}

export function useCreateObra() {
  const invalidate = useInvalidateObras();
  return useMutation({
    mutationFn: ({ nome, centroCusto }: { nome: string; centroCusto?: string | null }) =>
      api.createObra(nome, centroCusto),
    onSuccess: invalidate,
  });
}

export function useUpdateObra() {
  const invalidate = useInvalidateObras();
  return useMutation({
    mutationFn: ({ id, ...input }: { id: string } & Parameters<typeof api.updateObra>[1]) =>
      api.updateObra(id, input),
    onSuccess: invalidate,
  });
}

export function useDeleteObra() {
  const invalidate = useInvalidateObras();
  return useMutation({ mutationFn: api.deleteObra, onSuccess: invalidate });
}
